module.exports = __webpack_public_path__ + "gi.svg?9f13139786b951ae0fd128acfcbe2dbd";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/gi.svg
// module id = 1065
// module chunks = 27